import { render, staticRenderFns } from "./permissionConfig.vue?vue&type=template&id=729404f6&scoped=true&"
import script from "./permissionConfig.vue?vue&type=script&lang=js&"
export * from "./permissionConfig.vue?vue&type=script&lang=js&"
import style0 from "./permissionConfig.vue?vue&type=style&index=0&id=729404f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729404f6",
  null
  
)

export default component.exports